import { Component, inject } from "@angular/core";
import { DeviceCapabilityService } from "@services/device-capability.service";

@Component({
  selector: "app-reward-mecanism-touch-device-notice",
  template: `
    @let showTouchDeviceNotice = deviceCapabilityService.hasTouchCapabilities();

    @if (showTouchDeviceNotice) {
      <div class="touch-screen-notice" data-testid="touch-screen-notice">
        <img class="notice-icon" src="assets/icons/help.svg" />
        <p class="notice__content">Rends-toi sur ton ordinateur afin de profiter de tes récompenses!</p>
        <div class="notice-image">
          <img src="assets/touch-screen-notice-computer.svg" alt="Rends-toi sur ton ordinateur afin de profiter de tes récompenses!" />
        </div>
      </div>
    }
  `,
  styles: `
    .touch-screen-notice {
      position: relative;
      display: flex;
      gap: 8px;
      width: 100%;
      padding: 16px;
      padding-right: 55px;
      border-radius: none;
      background-color: #ecf7f8;

      .notice-icon {
        display: block;
        width: 20px;
        height: 20px;
      }

      .notice-content {
        font-size: 1.2rem;
      }

      .notice-image {
        position: absolute;
        top: 0;
        right: 0;
        width: 38px;
        height: 50px;
        background-color: #fff;
        border-radius: 3px;

        > img {
          display: block;
          width: 100%;
        }
      }
    }
  `,
})
export class RewardMechanismTouchDeviceNotice {
  protected deviceCapabilityService = inject(DeviceCapabilityService);
}
